module.exports = __webpack_public_path__ + "static/media/me.8cef10fa.png";